import request from '@/request/request'
import { tansParams } from "@/utils/src/tansParams";


//字典
export function getDictType(data) {
    return request({
        url: `/api/system-server/sysDictData/list?dictType=${data.type}`,
        method: 'get',
        data: data
    })
}
// 启动播放
export function startBroadcastTask(data) {
    return request({
        url: '/api/supplemental-api/supplemental/broadcastTask/start',
        method: 'post',
        data: data
    })
}

// 停止播放
export function stopBroadcastTask(data) {
    return request({
        url: '/api/supplemental-api/supplemental/broadcastTask/stop',
        method: 'post',
        data: data
    })
}
// 新增播单
export function addBroadcast(data) {
    return request({
        url: '/api/equipment-server/broadcastOrder',
        method: 'post',
        data: data
    })
}
// 编辑播单
export function editBroadcast(data) {
    return request({
        url: '/api/equipment-server/broadcastOrder/edit',
        method: 'post',
        data: data
    })
}
// 查询单个播单
export function BroadcastInfo(data) {
    return request({
        url: `/api/equipment-server/broadcastOrder/${data.id}`,
        method: 'get',
        data: {}
    })
}
// 删除单个播单
export function BroadcastDel(data) {
    return request({
        url: `/api/equipment-server/broadcastOrder/delete/${data.id}`,
        method: 'post',
        data: {}
    })
}
// 播单列表
export function BroadcastList(data) {
    return request({
        url: `/api/equipment-server/broadcastOrder/list?${tansParams(data)}`,
        method: 'get',
        data: data
    })
}
// 新增节目管理
export function addBroadcastShow(data) {
    return request({
        url: '/api/equipment-server/broadcastShow',
        method: 'post',
        data: data
    })
}
// 编辑节目管理
export function editBroadcastShow(data) {
    return request({
        url: '/api/equipment-server/broadcastShow/edit',
        method: 'post',
        data: data
    })
}
// 查询节目管理
export function BroadcastShowList(data) {
    return request({
        url: `/api/equipment-server/broadcastShow/list?${tansParams(data)}`,
        method: 'get',
        data: data
    })
}
// 查询节目管理单个信息
export function BroadcastShowInfo(data) {
    return request({
        url: `/api/equipment-server/broadcastShow/${data.id}`,
        method: 'get',
        data: data
    })
}
//删除节目管理
export function delBroadcastShow(data) {
    return request({
        url: `/api/equipment-server/broadcastShow/delete/${data.id}`,
        method: 'post',
        data: data
    })
}

//新增播单关联 
export function addBroadcastOrderShow(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderShow`,
        method: 'post',
        data: data
    })
}
//编辑播单关联 
export function editBroadcastOrderShow(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderShow/edit`,
        method: 'post',
        data: data
    })
}
//批量更新节目关联 
export function batchUpdate(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderShow/batchUpdate`,
        method: 'post',
        data: data
    })
}
//播单关联列表
export function BroadcastOrderShowList(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderShow/list?${tansParams(data)}`,
        method: 'get',
        data: data
    })
}

//新增手动广播
export function addBroadcastManual(data) {
    return request({
        url: `/api/equipment-server/broadcastManual`,
        method: 'post',
        data: data
    })
}
//修改手动广播
export function editBroadcastManual(data) {
    return request({
        url: `/api/equipment-server/broadcastManual/edit`,
        method: 'post',
        data: data
    })
}
//删除手动广播
export function delBroadcastManual(data) {
    return request({
        url: `/api/equipment-server/broadcastManual/delete/${data.id}`,
        method: 'post',
        data: data
    })
}
//查询手动广播
export function broadcastManualList(data) {
    return request({
        url: `/api/equipment-server/broadcastManual/list?${tansParams(data)}`,
        method: 'get',
        data: data
    })
}
//查询手动广播信息
export function lookBroadcastManual(data) {
    return request({
        url: `/api/equipment-server/broadcastManual/info/${data.equipmentId}`,
        method: 'get',
        data: data
    })
}
//批量更新设备关联
export function broadcastOrderBatchUpdate(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderEquipment/batchUpdate`,
        method: 'post',
        data: data
    })
}
//查询广播播单终端关联列表
export function broadcastOrderEquipmentList(data) {
    return request({
        url: `/api/equipment-server/broadcastOrderEquipment/listEquipment?${tansParams(data)}`,
        method: 'get',
        data: data
    })
}
//发布播单
export function startOrder(data) {
    return request({
        url: `/api/equipment-server/broadcastTask/startOrder`,
        method: 'post',
        data: data
    })
}
//停止播单
export function stopOrder(data) {
    return request({
        url: `/api/equipment-server/broadcastTask/stopOrder`,
        method: 'post',
        data: data
    })
}
//手动播放
export function playOrder(data) {
    return request({
        url: `/api/equipment-server/broadcastTask/play`,
        method: 'post',
        data: data
    })
}